"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskState = void 0;
var base_1 = require("../../adapters/base");
var utils_1 = require("./utils");
var utils_2 = require("./utils");
Object.defineProperty(exports, "TaskState", { enumerable: true, get: function () { return utils_2.TaskState; } });
var Scheduler = (function (_super) {
    __extends(Scheduler, _super);
    function Scheduler(store, period, runnerClass, logger) {
        if (period === void 0) { period = 1000; }
        var _this = _super.call(this) || this;
        _this.startupQueue = [];
        _this.runAllTasks = function () {
            Object.values(_this.tasks).forEach(function (_a) {
                var _b;
                var task = _a.task, options = _a.options, state = _a.state;
                if ((options === null || options === void 0 ? void 0 : options.delay) && state.shouldBeDelayed(options.delay)) {
                    return;
                }
                try {
                    task(_this.store.dispatch, _this.store.getState, state);
                    state.updateLastRun();
                }
                catch (e) {
                    (_b = _this.logger) === null || _b === void 0 ? void 0 : _b.warn("Unable to run task ".concat(task, ", got error ").concat(e));
                    state.updateLastRun();
                }
            });
        };
        _this.store = store;
        _this.period = period;
        _this.logger = logger;
        _this.lastTaskId = 0;
        _this.tasks = {};
        _this.t = 0;
        _this.done = null;
        _this.runner = new runnerClass(period, _this.runAllTasks, 100, _this.logger);
        return _this;
    }
    Scheduler.prototype.setOnStartup = function (task) {
        this.onStartup = task;
    };
    Scheduler.prototype.addPeriodicTask = function (task, options) {
        var taskId = this.lastTaskId++;
        this.tasks[taskId] = {
            task: task,
            options: options,
            state: new utils_1.TaskState(),
        };
        (options === null || options === void 0 ? void 0 : options.runOnStart) && this.startupQueue.push(taskId);
        return taskId;
    };
    Scheduler.prototype.runTaskManual = function (taskId) {
        var _a;
        var _b = (_a = this.tasks) === null || _a === void 0 ? void 0 : _a[taskId], task = _b.task, state = _b.state;
        if (!task) {
            throw new Error("No task found");
        }
        task(this.store.dispatch, this.store.getState, state);
        state.updateLastRun();
    };
    Scheduler.prototype.getStats = function () {
        var runnerStats = this.runner.getStats();
        return {
            runner: runnerStats,
            tasks: Object.values(this.tasks).map(function (task) {
                var _a, _b;
                return ({
                    title: (_a = task.options) === null || _a === void 0 ? void 0 : _a.title,
                    lastRun: task.state.lastRun,
                    delay: (_b = task.options) === null || _b === void 0 ? void 0 : _b.delay,
                });
            }),
        };
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        var _a, _b, _c;
        if (this.runner.started) {
            throw new Error("Scheduler already started");
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.info("Running startup tasks");
        while (true) {
            var taskId = this.startupQueue.shift();
            if (taskId !== undefined) {
                this.runTaskManual(taskId);
            }
            else {
                break;
            }
        }
        (_b = this.logger) === null || _b === void 0 ? void 0 : _b.info("Running on startup task");
        (_c = this.onStartup) === null || _c === void 0 ? void 0 : _c.call(this, this.store.dispatch, this.store.getState);
        this.runner.start();
        return new Promise(function (resolve) {
            _this.runner.setDoneCallback(resolve);
        });
    };
    Scheduler.prototype.stop = function () {
        this.runner.stop();
    };
    return Scheduler;
}(base_1.BaseAdapter));
exports.default = Scheduler;
//# sourceMappingURL=index.js.map